import {Employee} from '@shared/models/employee.model';
import {TopicCategory} from '@shared/models/topic-category.model';
import {TopicBookletDetails} from '@shared/models/topic-booklet.model';
import {SchoolingPlan} from "@shared/models/schooling-plan.model";

export class Topic {
  id: number = null;
  name: string = null;
  active: boolean = true;
  externalSchoolingAllowed: boolean = false;
  tuitionAllowed: boolean = true;
  allowOnline: boolean = false;
  copiedFromTopicId: number = null;
  description: string = '';
  comment: string = '';
  defaultAssignmentType: number = 0;
  defaultValidityInMonth: number = 12;
  defaultLeadTimeInMonth: number = 1;
  defaultExecutionTimeInMonth: number = -1;
  printCertificateOnFinish: boolean = false;
  defaultAssignmentStart: string = '01-01';
  defaultAssignmentEnd: string = '12-31';
  creatorEmployeeId: number = null;
  created: string = null;

  constructor(config?: Partial<Topic>) {
    if (config) {
      Object.keys(config)
        .filter(key => typeof config[key] !== 'undefined')
        .forEach(key => this[key] = config[key]);
    }
  }
}

export class TopicDetails {
  topic: Topic = new Topic();
  copiedFromTopic: Topic = null;
  creatorEmployee: Employee = null;
  categories: TopicCategory[] = [];
  bookletDetails: TopicBookletDetails[] = [];
  categoryIds: number[] = [];
}

export interface TopicStatusModel {
  topic: Topic;
  plans: SchoolingPlan[];
  status: number;
}
